import { useDispatch } from "react-redux";

import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import { toggleNavDrawer } from "../../redux/actions/layout";

const JustNavLayout = ({ children }) => {
  const dispatch = useDispatch();

  const toggleNav = () => dispatch(toggleNavDrawer());
  let agent_service = localStorage.getItem("agent_service");
  return (
    <>
      <Paper
        sx={{
          position: "fixed",
          top: "15px",
          left: "15px",
          zIndex: "1000",
          borderRadius: "50%",
        }}
      >
        {agent_service === null && (
          <IconButton onClick={toggleNav} sx={{ boxShadow: 3 }}>
            <MenuIcon fontSize="large" />
          </IconButton>
        )}
      </Paper>

      {children}
    </>
  );
};

export default JustNavLayout;
